import React from "react";
import { Helmet } from "react-helmet";
import Slider from "./Slider/Slider";
import Certificate from "./Certification/Certificate";
import Industry from "./Industry/Industry";
import Grid from "./Grid/Grid";
import Loader from "../../Loader/Load";
import "./Student.scss";

const Student = () => {
  return (
    <>
      {/*  SEO Meta Tags */}
      <Helmet>
        <title>Best Programming Course Training in Vadodara</title>
        <meta
          name="title"
          content="Best Programming Course Training in Vadodara"
        />
        <meta
          name="description"
          content="V-Ex Tech Solution offers the best practical programming courses in Vadodara. Learn job-ready skills with live project-based training and expert guidance in high-demand technologies."
        />
        <meta
          name="keywords"
          content="programming training Vadodara, coding classes Vadodara, full stack course Vadodara, Python training Vadodara, React training Vadodara, V-Ex Tech Solution"
        />
      </Helmet>

      {/*  Page Loader */}
      <Loader />

      {/*  Student Training Page Sections */}
      <div className="student-page">
        <Slider />
        <Grid />
        <Certificate />
        <Industry />
      </div>
    </>
  );
};

export default Student;
